module.exports = __webpack_public_path__ + "img/cart.e81fa04.svg";